import { render, staticRenderFns } from "./MedicosSV.vue?vue&type=template&id=4d10cada&"
import script from "./MedicosSV.vue?vue&type=script&lang=js&"
export * from "./MedicosSV.vue?vue&type=script&lang=js&"
import style0 from "./MedicosSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports